const LabeledText = ({ label, value }) => (
  <div className="gap-2 flex">
    <p className="text-[16px] font-bold tracking-wide">{label}:</p>
    <p className="text-[15px] tracking-wide">{value ? value : "N/A"}</p>
  </div>
)

export default LabeledText
